import { t } from "@/lib/i18n";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const tr = (k) => t(k);

export const guestValid = (f) => f.guest_name.trim().length >= 2 && EMAIL_RE.test(f.guest_email.trim()) && f.guest_phone.replace(/\D/g, "").length >= 6;

const Input = ({ label, testid, ...props }) => (
  <label className="block">
    <span className="ff-label">{label}</span>
    <input data-testid={testid} className="ff-field" {...props} />
  </label>
);

export const GuestContact = ({ form, set }) => (
  <div data-testid="guest-contact" className="ff-card p-4 flex flex-col gap-3 border-[#10B981]/40">
    <div>
      <span className="ff-label !mb-0">{tr("I tuoi recapiti")}</span>
      <p className="text-xs text-[#94A3B8] mt-1">{tr("Nessuna password: creiamo il tuo profilo in automatico per gestire la corsa e ricevere il 90%.")}</p>
    </div>
    <Input label={tr("Nome e Cognome / Ragione sociale")} testid="guest-name-input" autoComplete="name" placeholder="Es. Mario Rossi NCC" value={form.guest_name} onChange={(e) => set("guest_name")(e.target.value)} />
    <Input label="Email" testid="guest-email-input" type="email" autoComplete="email" inputMode="email" placeholder="nome@email.it" value={form.guest_email} onChange={(e) => set("guest_email")(e.target.value)} />
    <Input label={tr("Telefono")} testid="guest-phone-input" type="tel" autoComplete="tel" inputMode="tel" placeholder="+39 333 1234567" value={form.guest_phone} onChange={(e) => set("guest_phone")(e.target.value)} />
  </div>
);
